import config from '@config';

export function showHelp() {
    // window.zE('webWidget', 'show');
}

export function hideHelp() {
    // window.zE('webWidget', 'hide');
}

export function openChat() {
    // window.zE.activate({ hideOnClose: true });
}

export function initializeHelpBot() {
    // zendesk chat widget exists globally, but is hidden by default
    // window.zE('webWidget', 'setLocale', config.language);
    // window.zE('webWidget', 'hide');
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/help/index.ts